"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalUpdateProfileInput = void 0;
const typebox_1 = require("@sinclair/typebox");
const address_transport_1 = require("./address-transport");
exports.PortalUpdateProfileInput = typebox_1.Type.Partial(typebox_1.Type.Object({
    contact: typebox_1.Type.Partial(typebox_1.Type.Object({
        email: typebox_1.Type.String({ format: 'email' }),
        firstName: typebox_1.Type.String(),
        lastName: typebox_1.Type.String(),
        phoneNumber: typebox_1.Type.String(),
        sendBillingEmails: typebox_1.Type.Boolean(),
        sendDispatchEmails: typebox_1.Type.Boolean(),
    })),
    companyName: typebox_1.Type.String(),
    billingAddress: address_transport_1.AddressTransport,
}));
//# sourceMappingURL=customer-portal.js.map